import * as React from 'react';

import Grid from '@mui/material/Grid';

import { IVideoDetails } from '../interfaces';

interface ModalVideoPlayerProps {
  videoUrl: string;
  isSelfHosted: boolean;
  title?: string;
  description?: string;
  relatedVideos?: string[];
  potentialVideos?: { [key: string]: IVideoDetails };
  onClose: () => void;
}

function ModalVideoPlayer(props: ModalVideoPlayerProps) {
  const [shouldShowModal, setShouldShowModal] = React.useState(true);
  const [videoUrl, setVideoUrl] = React.useState(props.videoUrl);
  const [isSelfHosted, setIsSelfHosted] = React.useState(props.isSelfHosted);
  const [title, setTitle] = React.useState(props.title);
  const [description, setDescription] = React.useState(props.description);
  const [relatedVideos, setRelatedVideos] = React.useState(props.relatedVideos);
  const [potentialVideos, setPotentialVideos] = React.useState(props.potentialVideos);

  const closeModal = (): void => {
    setShouldShowModal(false);
    props.onClose();
  };

  React.useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const updateModal = (videoKey: string) => {
    if (props.potentialVideos) {
      setVideoUrl(props.potentialVideos[videoKey].videoUrl);
      setIsSelfHosted(props.potentialVideos[videoKey].isSelfHosted);
      setTitle(props.potentialVideos[videoKey].title);
      setDescription(props.potentialVideos[videoKey].description);
      setRelatedVideos(props.potentialVideos[videoKey].relatedVideos);
      setPotentialVideos(props.potentialVideos);
    }
  };

  return shouldShowModal ? (
    <Grid
      container
      className="modal-container"
      alignItems="center"
      justifyContent="center"
      data-qa="modal-video-player"
    >
      <button className="close-button" onClick={closeModal}>
        X
      </button>
      {isSelfHosted ? (
        <video data-qa="video-player" controls src={videoUrl} className="video-player" autoPlay />
      ) : (
        <iframe
          className="video-player"
          src={videoUrl}
          title="Skillz YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      )}
      {description && (
        <div className="modal-video-extra-content">
          <h3 className={`home-page__tutorial-video-card-bottom-title`}>{title}</h3>
          <p className="home-page__tutorial-video-card-bottom-description">{description}</p>
        </div>
      )}
      {potentialVideos && relatedVideos && (
        <div className="modal-video-related-videos">
          <h3 className={`home-page__tutorial-video-card-bottom-title`}>Related Videos</h3>
          <div className="related-video-container">
            {relatedVideos.map((videoKey) => {
              const videoDetails = potentialVideos ? potentialVideos[videoKey] : undefined;
              if (videoDetails) {
                const bgStyle = {
                  backgroundImage: `url(${videoDetails.companyLogoUrl})`,
                };

                return (
                  <div
                    key={videoKey}
                    className="related-video"
                    onClick={() => updateModal(videoKey)}
                    style={bgStyle}
                  >
                    <h4>{videoDetails.title}</h4>
                  </div>
                );
              } else {
                return <></>;
              }
            })}
          </div>
        </div>
      )}
    </Grid>
  ) : (
    <></>
  );
}

export { ModalVideoPlayer };
